import { ReactNode } from 'react'
import * as React from 'react'
import { SectionHintContainer } from './styles'

export const SectionHint: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <SectionHintContainer>{children}</SectionHintContainer>
}
